import { Header, AnnouncementBar, Footer } from "@/components/Layout";
import { SITE } from "@/lib/site";
import { useSeo } from "@/lib/seo";

const SECTIONS = [
    {
        h: "Who we are",
        p: `These Terms of Service ("Terms") apply to the website 5starhelpme.com, operated by 5 Star Construction Services LLC, an Oregon limited liability company and licensed general contractor (CCB #232477) based in Medford, Oregon. By using this website you agree to these Terms.`,
    },
    {
        h: "What this website is",
        p: `This website is a marketing site that tells you about our handyman, repair, and manufactured-home services and lets you request contact, a quote, or service. The website does not process payments, sell digital goods, or provide automated services. To start any work, a representative will speak with you directly by phone, email, or in person.`,
    },
    {
        h: "Estimates & quotes",
        p: `Any prices, ranges, or examples shown on the website are illustrative only. A binding price for your specific project is provided in a written estimate after we assess the work. Estimates are typically valid for 30 days and may be revised if scope, materials, or site conditions change.`,
    },
    {
        h: "Scheduling",
        p: `When we schedule a service, both parties agree to give at least 24 hours' notice for cancellations or changes whenever possible. We do our best to be on time and to communicate promptly when we can't.`,
    },
    {
        h: "Workmanship",
        p: `All work is performed by 5 Star Construction Services LLC under Oregon CCB #232477 and applicable local permits and regulations. We carry liability insurance and bonding as required by Oregon state law for licensed general contractors.`,
    },
    {
        h: "No warranties on website content",
        p: `The information on this website is provided "as is." We make no guarantee that every service is available in every area or that pricing examples will match your situation. The website may contain typos or out-of-date information from time to time; please call us to confirm anything you plan to rely on.`,
    },
    {
        h: "Use of the website",
        p: `You agree not to attempt to break into, scrape, or interfere with the website, submit false information through our contact forms, or use the website to send spam.`,
    },
    {
        h: "Governing law",
        p: `These Terms are governed by the laws of the State of Oregon. Any dispute will be handled in the state or federal courts of Jackson County, Oregon.`,
    },
    {
        h: "Contact",
        p: `Questions about these Terms? Call 541-292-9620 or email 5starhelpllc@gmail.com.`,
    },
];

export default function Terms() {
    useSeo({
        title: "Terms of Service | 5 Star Construction Services LLC · Medford, Oregon",
        description: "Terms of service for 5starhelpme.com — the basic rules for using the website and what to expect when you hire 5 Star Construction Services LLC.",
        path: "/terms",
    });
    return (
        <div className="bg-[#F6F5F2] min-h-screen">
            <AnnouncementBar />
            <Header />
            <main>
                <section className="bg-[#111111] text-[#F6F5F2] border-b-4 border-[#E11D2A]">
                    <div className="max-w-[1100px] mx-auto px-6 md:px-12 py-16 md:py-20">
                        <div className="font-['Manrope'] text-xs font-bold tracking-[0.22em] uppercase text-[#E11D2A]">Legal</div>
                        <h1 className="mt-3 font-['Anton'] uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
                            Terms of Service
                        </h1>
                        <p className="mt-5 font-['Manrope'] text-base md:text-lg text-[#F6F5F2]/75 max-w-3xl">
                            The basic rules for using this website and what to expect when you hire us.
                        </p>
                    </div>
                </section>

                <section className="bg-[#F6F5F2]">
                    <div className="max-w-[1100px] mx-auto px-6 md:px-12 py-16 md:py-20">
                        {SECTIONS.map((s) => (
                            <div key={s.h} className="mb-10 last:mb-0">
                                <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-[#111812]">{s.h}</h2>
                                <p className="mt-3 font-['Manrope'] text-base md:text-lg text-[#5F5F5F] leading-relaxed">{s.p}</p>
                            </div>
                        ))}
                        <div className="mt-14 pt-8 border-t border-[#E2DFD8]">
                            <div className="font-['Manrope'] text-sm text-[#5F5F5F]">Last updated: December 2025</div>
                            <div className="font-['Manrope'] text-sm text-[#5F5F5F] mt-1">
                                5 Star Construction Services LLC · {SITE.license} · {SITE.city}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
